import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import baseUrl from "../../../baseUrl";
import EmptyData from "../EmptyData/EmptyData";
import Spinner from "../../Spinner/Spinner";
import { toast } from "react-toastify";

const ListQuestion = () => {
  const adminToken = JSON.parse(localStorage.getItem("EXAMNP:admin-token"));

  const navigate = useNavigate();
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(false);

  const { id } = useParams();

  // for loading exams list
  useEffect(() => {
    setLoading(true);
    axios
      .get(`${baseUrl}/admin/get-all-questions/${id}`, {
        headers: { Authorization: `Bearer ${adminToken}` },
      })
      .then((res) => {
        if (res.data.success === true) {
          setQuestions(res.data.questions.questions);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [adminToken, id]);

  // delete question
  const handleQuestionDelete = (_id) => {
    axios
      .post(
        `${baseUrl}/admin/delete-question/${_id}`,
        {
          id: _id,
          examId: id,
        },
        {
          headers: { Authorization: `Bearer ${adminToken}` },
        }
      )
      .then((res) => {
        setQuestions(questions.filter((item) => item._id !== _id));
        navigate("/admin/exam-details/" + id);
        toast.success(res.data.message);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      {loading && <Spinner />}
      <div>
        {questions.length <= 0 ? (
          <EmptyData message="Sorry! Questions data not found." />
        ) : (
          <section className="text-gray-700">
            <div className="container px-5 py-5 mx-auto">
              <div className="text-center mb-10">
                <h1 className="sm:text-3xl text-2xl font-medium text-center title-font text-gray-900 mb-4">
                  Questions List
                </h1>
              </div>
              <h1 className="font-bold text-xl mb-3">
                Multiple Choice Question
              </h1>

              {questions.map(
                (question) =>
                  question.questionType === "MCQ" && (
                    <div key={question._id}>
                      <details className="mb-4 cursor-pointer">
                        <summary className="font-semibold  bg-indigo-300 rounded-md py-2 px-4">
                          {question.question}
                        </summary>
                        <span
                          className={`ml-4 font-semibold  ${
                            question.correctOption === question.optionOne
                              ? "text-green-600"
                              : "text-red-600"
                          }`}
                        >
                          1 {question.optionOne}
                        </span>
                        <br />
                        <span
                          className={`ml-4 font-semibold  ${
                            question.correctOption === question.optionTwo
                              ? "text-green-600"
                              : "text-red-600"
                          }`}
                        >
                          2 {question.optionTwo}
                        </span>
                        <br />
                        <span
                          className={`ml-4 font-semibold  ${
                            question.correctOption === question.optionThree
                              ? "text-green-600"
                              : "text-red-600"
                          }`}
                        >
                          3 {question.optionThree}
                        </span>
                        <br />
                        <span
                          className={`ml-4 font-semibold  ${
                            question.correctOption === question.optionFour
                              ? "text-green-600"
                              : "text-red-600"
                          }`}
                        >
                          4 {question.optionFour}
                        </span>
                        <br />
                        <br />
                        <i
                          className="fa-solid fa-trash-can flex-1 ml-3 text-red-500 hover:text-red-700"
                          onClick={() => {
                            handleQuestionDelete(question._id);
                          }}
                        ></i>
                      </details>
                    </div>
                  )
              )}

              <h1 className="font-bold text-xl mb-3">Writtten Question</h1>

              {questions.map(
                (question) =>
                  question.questionType === "Written" && (
                    <div key={question._id} className="mb-4 cursor-pointer">
                      <div className="font-semibold  bg-indigo-300 flex rounded-md py-2 px-4">
                        {question.question}
                      </div>
                      <i
                        className="fa-solid fa-trash-can flex-1 ml-3 text-red-500 hover:text-red-700"
                        onClick={() => {
                          handleQuestionDelete(question._id);
                        }}
                      ></i>
                    </div>
                  )
              )}
            </div>
          </section>
        )}
      </div>
    </>
  );
};

export default ListQuestion;
